// extracted by mini-css-extract-plugin
export default {"storeLocation":"Ra73oym4xxSlmE37oib9"};